import { useEffect, useRef } from "react";
import { useFormikContext } from "formik";

const useFocusOnError = ({ fieldRef, name }) => {
  const { submitCount, isValid, errors } = useFormikContext();
  const prevSubmitCountRef = useRef(submitCount);
  const firstErrorKey = Object.keys(errors)[0];
  useEffect(() => {
    if (!isValid && prevSubmitCountRef.current !== submitCount) {
      if (fieldRef.current && firstErrorKey === name) {
        fieldRef.current.focus();
      }
      prevSubmitCountRef.current = submitCount;
    }
  }, [submitCount, isValid, fieldRef, firstErrorKey, name]);
};

export default useFocusOnError;
